import { ApplicationSimplifyService } from './../application-simplify.service';
import { Component, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { Countries } from 'src/app/model/countries';
import { AuthService } from '../../auth/services/auth.service';
import { SpinnerServiceService } from '../../shared/serviceSpinner/spinner-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LOCALISATIONS } from 'src/app/model/localisations';
import { ProfilDetailsHorsParcours } from 'src/app/model/profilDetailsHorsParcours';

@Component({
  selector: 'app-form-appel-simplify',
  templateUrl: './form-appel-simplify.component.html',
  styleUrls: ['./form-appel-simplify.component.css'],
})
export class FormAppelSimplifyComponent implements OnInit {
  soumissionForm!: FormGroup;
  showEmailErrors$ = new BehaviorSubject<boolean>(false);
  countries!: Countries[];
  diplomes!: any;
  regions!: any;
  zones!: any;
  showPopup: boolean = false;
  paramValue?: string;
  paramValueDER_TABA?: string;
  paramsIncorrecte?: string = 'invalid';
  invalid: boolean = false;
  showHandicapChoiceRadio = false;
  chooseAHandicapMoteur = false;
  chooseAHandicapAuditif = false;
  chooseAHandicapVisuel = false;
  chooseAHandicapAutre = false;
  existe: boolean = false;
  statutOptions: string[] = [
    'Diplômé/Sans emploi',
    'Etudiant',
    'Employé (CDD, CDI)',
    'Entrepreneur ou freelance',
    'Chercher un emploi',
  ];

  handicapOptions: string[] = [
    'Handicap visuel',
    'Handicap moteur',
    'Handicap auditif',
    'Autre handicap',
    'Non concerné',
  ];

  showWhatsAppNumberFields: boolean = false;
  phoneCodeWhatsapp!: any[];
  phoneCode!: any[];
  controlsList: string[] = [
    'firstname',
    'lastname',
    'dateBirth',
    'gender',
    'phoneNumber',
    'phoneCode',
    'isWhatsApp',
    'emailGroup.email',
    'emailGroup.confirmEmail',
    'nationality',
    'situation',
    'placeOffResidence',
    'selectedZone',
    'inHandicapSituation',
    'current_status',
  ];
  isSucces: boolean = false;
  isError: boolean = false;
  session: boolean = false;
  noSession: boolean = false;
  applied: boolean = false;
  showSpinner: boolean = false;
  cohorteAppel: any = null;
  isLoading: boolean = false;
  params: any = null;
  webinaire: any[] = [];
  constructor(
    private formBuilder: FormBuilder,
    private service: ApplicationSimplifyService,
    private authService: AuthService,
    private spinnerService: SpinnerServiceService,
    private router: Router,
    private activated: ActivatedRoute,
  ) {
    this.soumissionForm = this.formBuilder.group({
      firstname: [null, Validators.required],
      lastname: [null, Validators.required],
      dateBirth: [null, Validators.required],
      gender: [null, Validators.required],
      phoneNumber: [null, Validators.required],
      phoneCode: ['221', Validators.required],
      isWhatsApp: [null, Validators.required],
      whatsAppNumber: [null],
      phoneCodeForWhatsApp: ['221'],
      emailGroup: this.formBuilder.group({
        email: [null, [Validators.required, Validators.email]],
        confirmEmail: [null, [Validators.required, Validators.email]],
      }),
      nationality: [null, Validators.required],
      situation: [null, Validators.required],
      high_diploma: [null, Validators.required],
      placeOffResidence: [null, Validators.required],
      selectedZone: [null, Validators.required],
      inHandicapSituation: [null],
      handicapSituations: this.formBuilder.array([]),
      current_status: this.formBuilder.array([], Validators.required),
      certificatChoice: [null],
      conditions: [null, Validators.requiredTrue],
      projectAfterCertificate: [null, Validators.required],
      webinaires: this.formBuilder.array([]),
    });
    this.soumissionForm
      .get('inHandicapSituation')
      ?.valueChanges.subscribe((value) => {
        if (value === 'Oui') {
          this.soumissionForm.setControl(
            'handicapSituations',
            this.formBuilder.array([], Validators.required),
          );
        } else {
          this.soumissionForm.setControl(
            'handicapSituations',
            this.formBuilder.array([]),
          );
        }
      });
  }

  ngOnInit(): void {
    this.cohorteAppel = this.activated.snapshot.paramMap.get('cohorte');
    this.params = this.activated.snapshot.paramMap.get('params');
    this.getWebinaireBycohorte();
    this.soumissionForm
      .get('isWhatsApp')
      ?.valueChanges.subscribe((isWhatsApp) => {
        if (isWhatsApp === 'NON') {
          this.showWhatsAppNumberFields = true;
          this.soumissionForm
            .get('whatsAppNumber')
            ?.addValidators(Validators.required);
          this.soumissionForm
            .get('phoneCodeForWhatsApp')
            ?.addValidators(Validators.required);
        } else {
          this.showWhatsAppNumberFields = false;
          this.soumissionForm.get('whatsAppNumber')?.clearValidators();
          this.soumissionForm.get('phoneCodeForWhatsApp')?.clearValidators();
        }
      });

    //handicap
    this.showHandicapChoices();
    //countries

    this.authService.getCountries().subscribe((data) => {
      this.countries = data.sort((c, d) => (c.name < d.name ? -1 : 1));
      // console.log('country :', this.countries);
    });
    this.authService.getCountries().subscribe((data) => {
      //console.log(data);
      this.phoneCode = data.sort((c, d) => c.phoneCode - d.phoneCode);
      //console.log(this.phoneCode);
      this.phoneCodeWhatsapp = this.phoneCode;
    });

    //region
    this.regions = LOCALISATIONS.Regions;
    //diplomes
    this.diplomes = ProfilDetailsHorsParcours.DiplomeForApplications;
    //zones
    this.zones = LOCALISATIONS.Zones;

    this.soumissionForm.get('nationality')?.valueChanges.subscribe((values) => {
      if (values === 'Autre') {
        this.soumissionForm.addControl(
          'otherCountry',
          this.formBuilder.control(null, Validators.required),
        );
        this.controlsList.push('otherCountry');
      } else {
        this.soumissionForm.removeControl('otherCountry');
        this.controlsList = this.controlsList.filter(
          (e) => e !== 'otherCountry',
        );
      }
    });
    this.watchHandicapSelection();
  }

  // Gestion des cases à cocher
  onCheckboxChange(event: any) {
    const formArray: FormArray = this.soumissionForm.get(
      'current_status',
    ) as FormArray;

    if (event.target.checked) {
      formArray.push(new FormControl(event.target.value));
    } else {
      let index = formArray.controls.findIndex(
        (x) => x.value === event.target.value,
      );
      if (index !== -1) {
        formArray.removeAt(index);
      }
    }
  }

  // Fonction pour gérer les changements des checkboxes
  onHandicapCheckboxChange(event: any) {
    const handicapSituationsArray = this.soumissionForm.get(
      'handicapSituations',
    ) as FormArray;

    if (event.target.checked) {
      // Ajouter uniquement si ce n'est pas déjà présent
      if (!handicapSituationsArray.value.includes(event.target.value)) {
        handicapSituationsArray.push(new FormControl(event.target.value));
      }
    } else {
      // Supprimer la valeur si décochée
      let index = handicapSituationsArray.value.indexOf(event.target.value);
      if (index !== -1) {
        handicapSituationsArray.removeAt(index);
      }
    }

    // Déclencher la validation manuellement
    handicapSituationsArray.markAsTouched();
    handicapSituationsArray.updateValueAndValidity();
  }

  showZoneOfResidenceDiv(): boolean {
    return this.soumissionForm.get('placeOffResidence')?.value !== 'Dakar';
  }
  getWebinaireBycohorte() {
    this.spinnerService.showSpinner();

    this.service.getwebinarByCohorte(this.cohorteAppel).subscribe({
      next: (data) => {
        this.webinaire = data;
        console.log(this.webinaire);

        const webinaireFormArray = this.formBuilder.array(
          this.webinaire.map((w: any) =>
            this.formBuilder.group({
              id: [w.id],
              title: [w.displayName],
              description: [w.description],
              startTime: [w.startTime],
              endTime: [w.endTime],
              date: [w.date],
              moderatorFullName: [w.moderatorFullNames],
              selected: [null, Validators.required],
            }),
          ),
        );

        this.soumissionForm.setControl('webinaires', webinaireFormArray);
        if (!this.webinaire[0]) {
          this.noSession = true;
        } else {
          this.session = true;
        }
      },
      error: (err) => {
        console.error(err);
      },
      complete: () => {
        this.spinnerService.hideSpinner();
      }
    });
  }
  get webinairesFormArray(): FormArray {
    return this.soumissionForm.get('webinaires') as FormArray;
  }

  onSubmitForm() {
    if (this.soumissionForm.invalid) {
      this.showPopup = true;
      this.soumissionForm.markAllAsTouched();
      return;
    }
    const formValue = this.soumissionForm.value;
    const selectedWebinarIds = formValue.webinaires
      .filter((w: any) => w.selected === 'oui')
      .map((w: any) => w.id);
    const requestPayload = {
      id: null,
      firstName: formValue.firstname,
      lastName: formValue.lastname,
      dateBirth: formValue.dateBirth,
      age: this.Age(formValue.dateBirth),
      gender: formValue.gender,
      phoneNumber: formValue.phoneNumber,
      whatsappNumber:
        formValue.isWhatsApp === 'OUI'
          ? formValue.phoneCode + formValue.phoneNumber
          : formValue.phoneCodeForWhatsApp + formValue.whatsAppNumber,
      email: formValue.emailGroup.email,
      confirmEmail: formValue.emailGroup.confirmEmail,
      isFrom: this.params,
      nationality: formValue.nationality,
      current_status: formValue.current_status,
      projectAfterCertificate: formValue.projectAfterCertificate,
      placeOffResidence: formValue.placeOffResidence,
      situation: formValue.situation,
      high_diploma: formValue.high_diploma,
      cohorte: this.cohorteAppel,
      confirmation: false,
      isWebinaire: true,
    };

    // var webinarId = [152, 153];
    // console.log(selectedWebinarIds);

    this.applySimplify(requestPayload, selectedWebinarIds);
  }

  applySimplify(formValue: any, webinarId: number[]) {
    this.isLoading = true;
    this.service.addAppel(formValue, webinarId).subscribe({
      next: (data) => {
        this.isSucces = true;
        this.isLoading = false;
        sessionStorage.setItem('canSuccess', '1');
        setTimeout(() => {
          this.soumissionForm.reset();
          this.isSucces = false;
          this.isLoading = false;
          var url =
            'confirmationappelsimp/application-simplify/' +
            this.cohorteAppel +
            '/' +
            this.params;
          this.router.navigateByUrl(url);
        }, 500);
      },
      error: (error) => {
        this.isError = true;
        this.isLoading = false;
        console.log(error);
        if (error.error.httpStatusCode == 409) {
          this.existe = true;
        }
      },
    });
  }
  showError() {
    this.isError = !this.isError;
    this.existe = false;
  }

  Age(dateOfBirth: string): number {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    console.log('Age', age);
    return age;
  }
  addHandicapsArray(): void {
    this.soumissionForm.addControl(
      'handicaps_moteur',
      this.formBuilder.control(false), // Ajout de la validation requise
    );
    this.soumissionForm.addControl(
      'handicaps_visuel',
      this.formBuilder.control(false),
    );
    this.soumissionForm.addControl(
      'handicaps_auditif',
      this.formBuilder.control(false),
    );
    this.soumissionForm.addControl(
      'handicaps_autre',
      this.formBuilder.control(false),
    );
  }

  showHandicapChoices(): void {
    this.soumissionForm
      .get('inHandicapSituation')
      ?.valueChanges.subscribe((inHandicapSituation) => {
        if (inHandicapSituation === 'Oui') {
          this.showHandicapChoiceRadio = true;

          this.addHandicapsArray();
          this.handicapCheck();
        } else {
          this.showHandicapChoiceRadio = false;
          this.removeHandicapsArray();
        }
      });
  }
  removeHandicapsArray(): void {
    this.soumissionForm.removeControl('handicaps_visuel');
    this.soumissionForm.removeControl('handicaps_moteur');
    this.soumissionForm.removeControl('handicaps_auditif');
    this.soumissionForm.removeControl('handicaps_autre');
  }
  handicapCheck(): void {
    this.soumissionForm
      .get('handicaps_moteur')
      ?.valueChanges.subscribe((moteur) => {
        //console.log('moteur: ', moteur);
        if (moteur === true) {
          //console.log('moteur: ', moteur);
          this.chooseAHandicapMoteur = false;
        } else {
          this.chooseAHandicapMoteur = true;
        }
      });
    this.soumissionForm
      .get('handicaps_visuel')
      ?.valueChanges.subscribe((visuel) => {
        if (visuel === true) {
          this.chooseAHandicapVisuel = false;
        } else {
          this.chooseAHandicapVisuel = true;
        }
      });
    this.soumissionForm
      .get('handicaps_auditif')
      ?.valueChanges.subscribe((auditif) => {
        if (auditif === true) {
          this.chooseAHandicapAuditif = false;
        } else {
          this.chooseAHandicapAuditif = true;
        }
      });
    this.soumissionForm
      .get('handicaps_autre')
      ?.valueChanges.subscribe((autre) => {
        if (autre === true) {
          this.chooseAHandicapAutre = false;
        } else {
          this.chooseAHandicapAutre = true;
        }
      });
  }

  watchHandicapSelection() {
    this.soumissionForm
      .get('inHandicapSituation')
      ?.valueChanges.subscribe((value) => {
        if (value === 'Oui') {
          this.showHandicapChoiceRadio = true;
        } else {
          this.showHandicapChoiceRadio = false;
          this.chooseAHandicapMoteur = false;
          this.chooseAHandicapAuditif = false;
          this.chooseAHandicapVisuel = false;
          this.chooseAHandicapAutre = false;
        }
      });
  }

  isFieldInvalid(controlName: string): boolean | null {
    const control = this.soumissionForm.get(controlName);
    return control && control.invalid && control.touched;
  }

  isFieldInvalidForMails(controlName: string): boolean | null {
    const control = this.soumissionForm.get(controlName);
    return control && control.errors?.['required'] && control.touched;
  }

  isMailFieldInvalid(control: string): boolean | null {
    return (
      this.soumissionForm.get(control)?.errors?.['email'] &&
      this.soumissionForm.get(control)?.touched
    );
  }
}
